module.exports = __webpack_public_path__ + "img/hnkcLogo.a9ad2434.png";